import { RegularSelectInput, Show, TextArea, TextInput } from "components/core";

import { Cheque_status } from "_graphql/__generated__/globalTypes-kek";
import { FC } from "react";
import { FormikProps } from "formik";
import clsx from "clsx";

export interface ClearChequeFormProps {
  form: FormikProps<any>;
}

const ClearChequeForm: FC<ClearChequeFormProps> = ({ form }) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div className="pt-3">
        <div className={clsx("grid grid-cols-2 gap-2")}>
          <div className="col-span-2">
            <RegularSelectInput
              options={[
                {
                  label: "Cleared",
                  value: Cheque_status.CLEARED,
                },
                {
                  label: "Uncleared",
                  value: Cheque_status.UNCLEARED,
                },
                // {
                //   label: "Pending",
                //   value: Cheque_status.PENDING,
                // },
              ]}
              id="clearance.clearance_status"
              label="Clearance Status"
              placeholder="e.g. Select Clearance Status"
              required={true}
              {...form}
            />
          </div>
          <div className={clsx("col-span-2")}>
            <TextInput
              type="date"
              id="clearance.cleared_date"
              label="Date Cheque cleared"
              placeholder="e.g. Enter Date Cheque cleared"
              required={true}
              {...form}
            />
          </div>
          <Show
            if={
              form.values.clearance?.clearance_status ===
              Cheque_status.UNCLEARED
            }
          >
            <div className={clsx("col-span-2")}>
              <TextArea
                id="clearance.reason"
                label="Reason"
                placeholder="e.g. Enter Reason"
                required={true}
                {...form}
              />
            </div>
          </Show>
        </div>
      </div>
    </div>
  );
};

export default ClearChequeForm;
